import React, { Component } from 'react';
import { PropTypes } from "prop-types"
import { Panel, FormControl, FormGroup, InputGroup, Button, Table, Row, Col } from 'react-bootstrap'
import moment from 'moment'
import { CSVLink } from 'react-csv'
import { blue, green, warning, red, darkgray } from '../../../../../utils/constants'
import './FileInput.css';
import { getSeasonWeeks, uploadRankingPoints, runRankings, getRankings } from '../../api'
import isEmpty from "../../../../../utils/isEmpty"

const ctrlMaxHeight = {
	maxHeight:'32px'
}
const selectStyle = { 
	maxWidth:'115px',
	borderRadius:'0',
	padding:'5px 2px 5px 2px',
	...ctrlMaxHeight
}
const selectStyleWeeks = { 
	maxWidth:'288px',
	borderRadius:'0',
	padding:'5px 2px 5px 2px',
	...ctrlMaxHeight
}
const fileInputStyle = {
	maxWidth:'230px',
	borderRadius:'0',
	fontSize:'14px',
	padding:'5px',
	color:blue ,
	...ctrlMaxHeight
}
const ListHeaders = [
	{ label: 'Rank', key: 'rankingNo' },
	{ label: 'Team', key: 'teamName' },
	{ label: 'Events', key: 'evt' },
	{ label: 'Tier 1', key: 'tr1' },
	{ label: 'Avg', key: 'avg' },
	{ label: 'AvgEF', key: 'axEF' },
	{ label: 'PP', key: 'pPx2' },
	{ label: 'Total', key: 'total' } ,
	{ label: 'Previous', key: 'prv' } ,
	{ label: '+/- Change', key: 'diff' }  
];

export default class WhatIf extends Component {

static getDerivedStateFromProps(props) {
		console.log('getDerivedStateFromProps  nextProps', props)

		return { seasonweeks: props.seasonweeks };
 }
 
  constructor(props)
  {
    super(props)
    this.state = {
			rankingPointFile: '',
			runningRanking: false,
			rankingPointFileMissing: false,
			seasonweeks:[],
			season:'',
			weekNumber:0,
			tier:'1',
			gender:'M',
			uploadingRankingFile: false,
			successfulUpload: false,
			rankingDone:false,
			rankings:[],
			whatIfRankingList:[],
			seasonYear:''
		}
		
		this.handleSearch = this.handleSearch.bind(this)
		this.handleCancelWhatIf = this.handleCancelWhatIf.bind(this)
		this.handleOnFileChange = this.handleOnFileChange.bind(this)
		this.handleSeasonChange = this.handleSeasonChange.bind(this)
		this.populateSeasonWeeks = this.populateSeasonWeeks.bind(this)
		this.handleShowRankingPoints = this.handleShowRankingPoints.bind(this)
		this.handleRunWhatIf = this.handleRunWhatIf.bind(this)
		this.handleSaveTemplate = this.handleSaveTemplate.bind(this)
		this.handleValueChange = this.handleValueChange.bind(this)
		this.handleGenerateList = this.handleGenerateList.bind(this)
	}
	componentDidMount() {
		const  { seasonId, seasonYear } =  this.props.availablerankings[0] 
		const _this = this
		getSeasonWeeks(seasonId).then(function(response) {			
			_this.setState( { seasonweeks: response.data, season:seasonId,weekNumber:response.data[0].weekNumber, seasonYear:seasonYear })
		})
	}
	
	//#region Event Handlers
	handleGenerateList() {
		const { rankings } = this.state
		const whatIfRankingList = []
		const _this = this
		rankings.map(function(rank) {
			const { 
				teamName, 
				evt,
				rankingNo,
				tr1,
				avg,
				axEF,
				pPx2,
				total,
				prv,
				diff
			} = rank
			whatIfRankingList.push({
				rankingNo,
				teamName,
				evt,
				tr1,
				avg,
				axEF,
				pPx2,
				total,
				prv,
				diff
			})
		})
		_this.setState({ whatIfRankingList: whatIfRankingList }) 
	}
	handleValueChange(e) {
		const { id,value } = e.target
		// console.log('handleValueChange whatIf name, value', id, e.target.value)
		this.setState({ [id]:value })
	} 
	handleSearch() {
	}
	handleCancelWhatIf() {
    this.props.cancelShowWhatIf()
	}
	handleOnFileChange()
	{
		const fileSelected = this.uploadInput.files[0] ? true:false
		const rankingPointFile 		 =  fileSelected == true ? this.uploadInput.files[0].name:''
		this.setState({ 
			rankingPointFile,
			rankingPointFileMissing:false,
			successfulUpload:false,
			rankingDone:false,
			rankings:[]
		}) 
	}
	handleSeasonChange(e) {
		const  seasonId = e.target.value
		const seasonYear = e.target.key
		const _this = this
		getSeasonWeeks(seasonId).then(function(response) {	
			_this.setState({ 
				seasonweeks: response.data,
				weekNumber:response.data[0].weekNumber,
				season:seasonId,
				seasonYear:seasonYear,
				rankings:[] 
			})
		})
	}
	handleShowRankingPoints() {
  }
	handleRunWhatIf() {
		const { tier, season, weekNumber, gender,seasonYear } = this.state
		const _this = this
		console.log('tier, season, weekNumber, gender',tier, season, weekNumber, gender)
		this.setState({ 
			uploadingRankingFile: false,
			successfulUpload: false,
			runningRanking: true,
			rankingDone: false 
		})
		runRankings(seasonYear).then(function(response) {
			if (response.data) {
				_this.setState({ 
					runningRanking:false,
					rankingDone: true
				})
				getRankings(season,weekNumber,gender).then(function(response) {
					if (response.data) {
						console.log('getRankings data', response.data)
						_this.setState({ 
							runningRanking:false,
							rankingDone: false,
							rankings:response.data
						})
					}
				})
			}
		})
	}
	handleSaveTemplate(e) {
		e.preventDefault();
		const { tier, season, weekNumber, gender } = this.state
		const rankingfile = this.uploadInput.files[0]
		const formData = new FormData()
    const _this = this
		formData.append('weekNumber', weekNumber)
		formData.append('tier', parseInt(tier))
		formData.append('season',parseInt(season))
		formData.append('gender',gender)
		formData.append('rankingfile', rankingfile)
		this.setState({ 
			uploadingRankingFile: true,
			successfulUpload: false,
			rankingDone:false,
			rankings:[] 
		})
		uploadRankingPoints(formData).then(function(response) {
			if (response.data) {
				_this.setState({ 
					uploadingRankingFile:false,
					successfulUpload: true
				})
			}
		})
	}   
	//#endregion
	//#region supporting functions
	populateyears() {
		const { availablerankings } = this.props
		const option = availablerankings.map((seasonyear) => {
			return (<option value={seasonyear.seasonId} key={seasonyear.seasonYear}>{seasonyear.seasonName} </option>)
		})
		return option
	}
	populateSeasonWeeks() {
		const { seasonweeks } = this.state
		const option = seasonweeks.map((week) => {
			return (<option value={week.weekNumber} key={week.weekNumber}>{moment(week.startDate).format('LL')}{' - '}{moment(week.endDate).format('LL')}</option>)
		})
		return option
	}
	//#endregion
	render() {

	const { 
		rankingPointFile,
		runningRanking,
		rankingPointFileMissing,
		uploadingRankingFile,
		successfulUpload,
		rankingDone,
		rankings,
		whatIfRankingList 
	} = this.state

	const rankingPointsSelected = ((rankingPointFile == undefined) || (rankingPointFile.length == 0)) ? false:true
	const fileMessage = rankingPointsSelected == true ? rankingPointFile:'No file selected'
	const fileMessageColor = rankingPointsSelected  == true? green:warning
	const runningIcon = runningRanking  ? "fa fa-spinner fa-spin":"fa fa-bolt"
	const uploadingIcon = uploadingRankingFile  ? "fa fa-spinner fa-spin":"fa fa-upload"
	const rankingPointsFileMissing = rankingPointFile === '' || rankingPointFile === undefined

	return (<Panel>
			<h4 style={{ color: blue }}>What If Scenarios { rankingPointFile ? ' - ' + rankingPointFile  : ''}</h4>
			<span style={{ color: warning }}>Select ranking point file to run What if scenarios</span>
		
			<form id='whatifranking' encType="multipart/form-data" onSubmit={this.handleSaveTemplate} role="form" className="form-inline" style={{ marginTop:'10px' }}>
				<FormGroup id="searchby" className="searchby-filter">
					<FormControl id='season'  componentClass="select" placeholder="All"  style={selectStyle} onChange={this.handleSeasonChange}>
						{ this.populateyears() }
					</FormControl>
					<FormControl  id='weekNumber' componentClass="select" placeholder="All"  style={selectStyleWeeks} onChange={this.handleValueChange}>
						{ this.populateSeasonWeeks() }
					</FormControl>
					<FormControl id='gender'  componentClass="select" placeholder="All"  style={selectStyle} onChange={this.handleValueChange}>
						<option value='M'>Men</option>
						<option value='W'>Women</option>
					</FormControl>
					<FormControl id='tier'  componentClass="select" placeholder="All"  style={selectStyle} onChange={this.handleValueChange}>
						<option value='1'>Tier 1</option>
						<option value='2'>Tier 2</option>
					</FormControl>
				
					<label className="btn btn-default" style={fileInputStyle} >
						<i className="fa fa-file-excel-o" aria-hidden="true" />&nbsp;{' '}Select Ranking Points File (.xlsx) {' '}
						<input type='file'  accept=".xlsx" id="rankingfile" ref={(ref) => {this.uploadInput = ref;}}  style={{ display:'none',marginTop:'20px' }} onChange={this.handleOnFileChange}  />						
					</label>
					<label style={{ minWidth:'240px',color:fileMessageColor }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						{fileMessage}
					</label><br />
					<div style={{ margin:'8px 0 8px 0' }}>
						<Button onClick={this.handleCancelWhatIf} style={{ marginRight:'2px', minWidth:'90px', ...ctrlMaxHeight }}>
							<i className="fa fa-times" aria-hidden="true" />&nbsp;&nbsp;Cancel
						</Button>
						<Button type="submit" onClick={this.handleSaveTemplate} style={{ color:blue, marginRight:'2px',	...ctrlMaxHeight }} disabled={ rankingPointsFileMissing }>
							<i className={uploadingIcon} aria-hidden="true" />&nbsp;&nbsp;Upload Ranking Points
						</Button>
					{/* 	<Button onClick={this.handleShowRankingPoints} style={{ color:warning, marginRight:'2px',	...ctrlMaxHeight }} disabled={ rankingPointsFileMissing }>
							<i className="fa fa-times" aria-hidden="true" />&nbsp;&nbsp;Show Ranking Points
						</Button> */}
						<Button onClick={this.handleRunWhatIf} style={{ color:green, 	...ctrlMaxHeight }} disabled={ rankingPointsFileMissing || !successfulUpload }>
							<i className={runningIcon} aria-hidden="true" />&nbsp;&nbsp;Run What If
						</Button>
						<br />
					</div>
					{ rankingPointFileMissing && (<span style={{ color:red }}>
						<i className="fa fa-exclamation-triangle" aria-hidden="true" />&nbsp;&nbsp;Please select What If Ranking Points file
					</span>)
					}
					{ successfulUpload && (<span style={{ color:green }}>
						<i className="fa fa-info-circle" aria-hidden="true" />&nbsp;&nbsp;File successfully uploaded. You can now run &#8217;What if Rankings&#8217; .
					</span>)
					}
					{ rankingDone && (<span style={{ color:green }}>
						<i className="fa fa-info-circle" aria-hidden="true" />&nbsp;&nbsp;&#8217;What if Rankings&#8217; run successfully completed. Getting rankings...
					</span>)
					}
					<InputGroup />
					{  (!isEmpty(rankings)) && (rankings.length > 0) &&  (
					
					<Row>
						<div style={{ margin:'-10px 0 10px 15px' }}>
							<CSVLink 
								data={whatIfRankingList} 
								headers={ ListHeaders }
								filename='What If Rankings.csv'
								target='_blank' 
								style={{ border:`1px solid ${darkgray}`,padding:'7px',borderRadius:'3px',color:blue, fontSize:'13px' }}  					                                  
							>
								<i className="fa fa-file-excel-o" aria-hidden="true" />{'  '}<span onClick={this.handleGenerateList}>&nbsp;Export Rankings (.csv)</span>                                    
							</CSVLink>
						</div>
						<Col xs={12}>
							<Table striped>
								<thead>
									<tr>
										<th>Rank</th>
										<th>Team</th>
										<th>Events</th>
										<th>Tier 1</th>
										<th>Avg</th>
										<th>AvgEF</th>
										<th>PP</th>
										<th>Total</th>
										<th>Previous</th>
										<th>+/- &nbsp; Change</th>
									</tr>
								</thead>
								<tbody>
									{rankings.map((item, key) => (
									<tr key={key}>
										<td>{item.rankingNo}</td>
										<td>{item.teamName}</td>
										<td>{item.evt}</td>
										<td>{item.tr1}</td>
										<td>{item.avg}</td>
										<td>{item.axEF}</td>
										<td>{item.pPx2}</td>
										<td>{item.total}</td>
										<td>{item.prv}</td>
										<td>{item.diff}</td>
									</tr>
									))}
								</tbody>
							</Table>
						</Col>
					</Row>)}
        </FormGroup>
			</form>
  </Panel>)
 }
}
WhatIf.propTypes = {
	cancelShowWhatIf: PropTypes.func,
	availablerankings: PropTypes.array,
	// seasonweeks: PropTypes.array,
}


// WEBPACK FOOTER //
// ./src/components/pages/Ranking/components/whatIf/index.js